import { POPOVER_SELECTOR, POPOVER_TARGET } from '@anm/constants/embed';
import { VideoSizes } from '@anm/hosting-player';
import { FC } from 'react';

import { TextEmbedItem, TextEmbedWrapper } from './Wrapper';

export { TextEmbedItem, TextEmbedWrapper };

type TextEmbedProps = {
  text: string;
  sizes: VideoSizes;
  hostId: string;
};

const TextEmbed: FC<TextEmbedProps> = ({ text, sizes, hostId }: TextEmbedProps) => (
  <TextEmbedWrapper data-id={hostId} data-width={sizes.width} data-height={sizes.height} className={POPOVER_SELECTOR}>
    <TextEmbedItem data-target={POPOVER_TARGET}>{text}</TextEmbedItem>
  </TextEmbedWrapper>
);
export default TextEmbed;
